module.exports = __webpack_public_path__ + "static/media/button-sound.32194199.mp3";